'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var NumberIsInteger = exports.NumberIsInteger = Number.isInteger || function (value) {
  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/core/utilities/polyfills.js
// module id = 469
// module chunks = 3 4 5